/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomLayout from "../../Core/Layout/CustomLayout";
import useDebounce from "../../Core/hooks/useDebounce";
import Header from "./Header";
import CustomTable from "../../Core/Components/CustomTable";
import ContainerIcon from "../../Common/Svgs/ContainerIcon";
import { getTableContainerHeight } from "../../Utils/getTableContainerHeight";
import CustomPagination from "../../Core/Components/CustomPagination";
import { columns } from "./data/constants";
import QRCodeModal from "../../Core/Components/Modal/QRCodeModal";
import { updateQrCode } from "../../Redux/Slices/qrcode.slice";
import DeleteContainerModal from "./DeleteContainerModal";
import { updateContainer } from "../../Redux/Slices/container.slice";
import { getContainers } from "../../Redux/APIs/containersAPI";
import { getUserByEmail } from "../../Redux/APIs/systemUsersAPI";
import { getAllLocationsV3 } from "../../Redux/APIs/locationsAPI";
import ToastMessageModal from "./ToastMessageModal";
import { DEFAULT_LIMIT } from "../../Utils/constants";

const ContainerList = () => {
  const dispatch = useDispatch();

  const { deleteContainerModal, showToastMessage, containerList } = useSelector(
    (state) => state.containers,
  );

  const { viewModal } = useSelector((state) => state.qrCode);
  const { userDetails } = useSelector((state) => state.loggedInUser);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_LIMIT);

  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    hub: [],
    type: [],
  });

  const tableContainerRef = useRef(null);

  const debounceSearch = useDebounce(search, 500);

  // get charger list with filters
  useEffect(() => {
    const filterObj = {
      limit: pageSize,
      offset: ((currentPage || 1) - 1) * pageSize,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;
    if (filters.hub.length) filterObj.hubs = filters.hub;
    // if (filters.type.length) filterObj.type = filters.type;

    dispatch(getContainers(filterObj));
  }, [dispatch, currentPage, pageSize, debounceSearch, filters]);


  // close the toast message after 5 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      dispatch(
        updateContainer({
          key: "showToastMessage",
          value: {
            visible: false,
            data: {},
          },
        }),
      );
    }, 5000);

    return () => clearTimeout(timeout);
  }, [dispatch, showToastMessage.visible]);

  // fetch user details (to get permissions on every refresh)
  useEffect(() => {
    dispatch(getUserByEmail({ email: userDetails.email }));

    setTimeout(() => {
      dispatch(getAllLocationsV3());
    }, 3000);
  }, [dispatch]);

  return (
    <CustomLayout pageName="Containers">
      <div className="bg-background">
        <Header
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
        />

        <div
          className={`h-[calc(100vh-72px-160px-69px-40px)] ${
            containerList?.result?.length && "overflow-y-scroll"
          }`}
          ref={tableContainerRef}
        >
          <CustomTable
            disableScroll
            columns={columns}
            data={containerList?.result}
            emptyState={
              <ContainerIcon size={16} className="text-dark-grey-text" />
            }
            emptyStateHeight={getTableContainerHeight(tableContainerRef)}
            rowClassName="group"
            pagination={{
              pageSize,
              total: containerList.totalRecords,
              showSizeChanger: true,
              onShowSizeChange: (current, size) => {
                setPageSize(size);
                setCurrentPage(1);
              },
              onChange: (page, size) => {
                if (size && size !== pageSize) {
                  setPageSize(size);
                  setCurrentPage(1);
                } else {
                  setCurrentPage(page);
                }
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                return (
                  <CustomPagination
                    type={type}
                    current={current}
                    originalElement={originalElement}
                    totalRecords={Number(containerList?.totalRecords || 0)}
                  />
                );
              },
            }}

          />
        </div>
      </div>

      <DeleteContainerModal
        visible={deleteContainerModal?.visible}
        onCancel={() =>
          dispatch(
            updateContainer({
              key: "deleteContainerModal",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <QRCodeModal
        visible={viewModal?.visible}
        type={viewModal?.data?.assetType}
        onCancel={() =>
          dispatch(
            updateQrCode({
              key: "viewModal",
              value: { visible: false, data: {} },
            }),
          )
        }
      />

      <ToastMessageModal
        visible={showToastMessage.visible}
        onCancel={() =>
          dispatch(
            updateContainer({
              key: "showToastMessage",
              value: { visible: false, data: {} },
            }),
          )
        }
        title={showToastMessage?.data?.title}
        description={showToastMessage?.data?.description}
      />
    </CustomLayout>
  );
};

export default ContainerList;
